// Off-session auto reload charges skip Stripe Checkout, so the quoted price must say tax comes on top.
export const recurringTaxNote = (exclVatLabel: string, taxIncluded: boolean): string => {
  if (taxIncluded) return '';
  return exclVatLabel.startsWith('（') ? exclVatLabel : ` ${exclVatLabel}`;
};
